export default __webpack_public_path__ + "static/media/Ballroll_00119.418e684b.png";